import { isTodayInTimezone } from "@compass/shared/schema/dateUtils";
import dayjs from "lib/dayjs";
import { timeAgo } from "./timeAgo";

export const formatISODate = (dateString: string, timeZone: string) => {
    const date = dayjs(dateString).toDate();
    const options: Intl.DateTimeFormatOptions = {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone,
    };
    if (!isTodayInTimezone(date, timeZone)) {
        options.month = "short";
        options.day = "numeric";
    }
    return new Intl.DateTimeFormat("en-US", options).format(date);
};

export const formatISODateRelative = (dateString: string) => {
    const date = dayjs(dateString).toDate();
    return timeAgo.format(date);
};
